/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
export class TreeSelectionService { selectable: boolean = false; static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TreeSelectionService_tsickle_Closure_declarations() {
/** @type {?} */
TreeSelectionService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TreeSelectionService.ctorParameters;
/** @type {?} */
TreeSelectionService.prototype.selectable;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
